import { Outlet } from 'react-router';

import { AppHeader } from '@/components/app-shell/AppHeader';
import { FeatureErrorBoundary } from '@/components/app-shell/FeatureErrorBoundary';
import { useSessionByContext } from '@/features/assistant/hooks/useSessionByContext';
import { FirstRunProfileGate } from '@/features/auth/components/FirstRunProfileGate';
import { useRefreshMe } from '@/features/auth/hooks/useRefreshMe';
import { useTimezoneReconciliation } from '@/features/auth/hooks/useTimezoneReconciliation';
import { IntercomProvider } from '@/features/intercom/IntercomProvider';
import { useOfficeContextStore } from '@/utils/stores/useOfficeContextStore';

export function Home() {
  const contextInfo = useOfficeContextStore((state) => state.contextInfo);

  useRefreshMe();
  useTimezoneReconciliation();
  useSessionByContext({
    ...(contextInfo?.conversationId && { conversationId: contextInfo.conversationId }),
    ...(contextInfo?.itemId && { emailId: contextInfo.itemId }),
  });

  return (
    <IntercomProvider>
      <div className="h-viewport bg-back-bg2 flex flex-col overflow-hidden">
        <div className="flex flex-1 justify-center overflow-hidden">
          <Outlet />
        </div>
        <div className="flex justify-center">
          <FeatureErrorBoundary name="Navigation">
            <AppHeader />
          </FeatureErrorBoundary>
        </div>
        <FirstRunProfileGate />
      </div>
    </IntercomProvider>
  );
}
